import moment from "moment";
import React, { useRef, useState } from "react";
import DateInput from "../../inputs/date-input";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import submit from "submit-form";
import { getRandomPastelColor } from "../../../utils/annual-planner-helpers";
import Modal from "../../modal-new";

export const AddEventModal = ({
  from,
  to,
  athleteId,
  date,
  query,
  locals,
  organizationCoachId,
}) => {
  let randomColor = useRef(getRandomPastelColor());

  const [formState, setFormState] = useState({
    event_name: "",
    event_color: randomColor.current,
    event_from: from,
    event_to: to,
    event_description: "",
  });

  const { event_name, event_color, event_from, event_to, event_description } =
    formState;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!event_name || !event_color || !event_from || !event_description)
      return;
    let body = {
      athleteId,
      date,
      event_name,
      event_color,
      event_from,
      event_to,
      event_description,
    };

    const url = locals.path.split("annual-planner")[1];

    body.modalUrl = locals.path;
    body.modalParams = locals.query;

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit(`/actions/annual-planner/add-calendar-event`, {
      method: "POST",
      body,
    });
  };

  const handleChange = (input, payload) => {
    setFormState(Object.assign({}, formState, { [input]: payload }));
    if (input === "event_color") randomColor.current = payload;
  };

  return (
    <Modal className="annual-planner-modal add-event-modal" title={"Add Event"}>
      <div className="body">
        <form
          className="annual-planner-modal-form add-event-modal-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          id="add-event-form"
        >
          <div role="wrapper" className="flex-row">
            <div role="wrapper" className="event-name">
              <label className="label">Event Name</label>
              <input
                type={"text"}
                name="event_name"
                className="event-name"
                placeholder="Enter title"
                value={event_name}
                onChange={({ target: { value } }) =>
                  handleChange("event_name", value)
                }
              />
            </div>
            <div role="wrapper" className="event-color">
              <label className="label">Color</label>
              <InputColor
                onChange={({ target: { value } }) =>
                  handleChange("event_color", value)
                }
                value={randomColor.current}
                customClassNames={"event-color"}
              />
            </div>
          </div>
          <div role="wrapper" className="flex-row">
            <div role="wrapper" className="event-from">
              <label className="label">Date</label>
              <DateInput
                customClassNames="event-from"
                name="event_from"
                defaultValue={
                  event_from && moment(`${event_from}`).format("YYYY-MM-DD")
                }
                forceOnChange={true}
                onChange={(newDate) =>
                  handleChange(
                    "event_from",
                    Number(moment(newDate, "MMM D, YYYY").format("YYYYMMDD"))
                  )
                }
                datePlaceholder={"Select event start date"}
              />
            </div>
            <div role="wrapper" className="event-to">
              <label className={`label${!!!event_from ? " disabled" : ""}`}>
                Date Range (Optional)
              </label>
              <DateInput
                customClassNames="event-to"
                name="event_to"
                defaultValue={
                  event_to && moment(`${event_to}`).format("YYYY-MM-DD")
                }
                forceOnChange={true}
                disabled={!!!event_from ? true : false}
                onChange={(newDate) =>
                  handleChange(
                    "event_to",
                    Number(moment(newDate, "MMM D, YYYY").format("YYYYMMDD"))
                  )
                }
                datePlaceholder={"Select event end date"}
              />
            </div>
          </div>
          <div role="wrapper" className="event-description">
            <label>Description</label>
            <textarea
              type={"textarea"}
              name="event_description"
              className="event-description"
              placeholder="Enter description here..."
              value={event_description}
              onChange={({ target: { value } }) =>
                handleChange("event_description", value)
              }
            />
          </div>
        </form>
      </div>
      <footer className="add-event-footer">
        <button
          form="add-event-form"
          type="submit"
          role="button"
          data-button-type="primary"
          disabled={
            !event_name || !event_color || !event_from || !event_description
          }
        >
          Add
        </button>
      </footer>
    </Modal>
  );
};
